<template>
    <div id="hero" class="form-container home-step" :ref="stepName">
        <p class="dropdown-title">Mon cadeau préféré :</p>
        <GiftForm :is_dropdown="is_meta_dropdown"/>
        <b-button class="button is-primary next-button" @click="nextStep()" :disabled="!selectedGiftId" >Demander votre pack
        </b-button>
        <div class="gift-choice__trust">
            <img src="/images/giftchoice/trust-logo.png" alt="">
            <p><span>+ 275 000</span> personnes nous font confiance</p>
        </div>
        <b-loading :is-full-page="false" v-model="loading"></b-loading>
    </div>
</template>

<script>
import mixin from "../../../travel_step_mixin";
import image_mixin from "../../../../../../views/_commons/fr/mixins/image_mixin";
import GiftForm from "./GiftForm.vue";
import {sync} from "vuex-pathify";

export default {
    mixins: [mixin,image_mixin],
    components:{GiftForm},
    computed: {
        selectedGiftId: sync('form_data/gift'),
    },
}
</script>
